import React from "react";
import { IonPage, IonContent, IonToolbar, IonIcon, IonText, IonButton, IonHeader, IonButtons, IonImg } from '@ionic/react';

import { useTranslation } from 'react-i18next';

import './KycProcessing.css';

import AppHeader from "../../../components/AppHeader/AppHeader";



const KycProcessing: React.FC = () => {

    const { t, i18n } = useTranslation();

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                
                <AppHeader
                title={t('kyc.processing.HEADER') as string}
                />
            </IonHeader>
            <IonContent>
            <div className="ion-text-center">
                    <IonImg className="profile_img" src="/assets/img/new_profile.png" />
                </div>
                <div className="ion-text-center">

                    <IonText>
                        <p >{t('kyc.processing.SUBHEADER')}</p>
                    </IonText>

                </div>
            </IonContent>
        </IonPage>
    )

}

export default KycProcessing